import { Navigate } from "react-router-dom";
import { useCompany } from "../companies/CompanyContext";

/**
 * Guards a route that requires a specific permission flag on the
 * currently selected company. If the selected company changes (e.g. via
 * the company switcher) and no longer has the permission, the user is
 * redirected to the dashboard overview.
 */
export default function RequireCompanyPermission({ permission, permissions, children }) {
  const { selectedCompany, loadingCompanies } = useCompany();

  // Wait until companies are loaded so we don't redirect on first render.
  if (loadingCompanies) {
    return null;
  }

  const required = permissions || (permission ? [permission] : []);
  const ok =
    selectedCompany && required.every((perm) => selectedCompany[perm] === true);

  if (!ok) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
